/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { signInActions } from 'modules/sign-in/slice';
/**
 * Define the the rate calendar upload feature initial state
 */
export const initialState = {
  loading: false,
  forceUploadConfirmation: false,
};
/**
 * Here mentioned all the rate calendar upload feature related actions
 */
export const rateCalendarUploadSlice = createSlice({
  name: SLICE.RATE_CALENDAR_UPLOAD,
  initialState,
  reducers: {
    rateCalendarUpload(state) {
      state.loading = true;
    },
    rateCalendarUploadSucceeded(state) {
      state.loading = false;
    },
    rateCalendarUploadFailed(state, action) {
      state.loading = false;
      state.forceUploadConfirmation = action?.payload?.message === 'duplicate data found';
    },
    rateCalendarForceUpload(state) {
      state.loading = true;
    },
    rateCalendarForceUploadSucceeded(state) {
      state.loading = false;
      state.forceUploadConfirmation = false;
    },
    rateCalendarForceUploadFailed(state) {
      state.loading = false;
      state.forceUploadConfirmation = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: rateCalendarUploadActions } = rateCalendarUploadSlice;
